import { render, staticRenderFns } from "./BizCom.vue?vue&type=template&id=5f9c8e14&scoped=true&"
import script from "./BizCom.vue?vue&type=script&lang=js&"
export * from "./BizCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c8e14",
  null
  
)

export default component.exports